export default __webpack_public_path__ + "static/n1-tag-ff1606794b416b76f3c3e56582f127dd.svg";